import waativaLogo from "../../assets/images/waativalogoteksilla.png";
import suomalainenLogo from "../../assets/images/Suomalaista_palvelua.png";

export const imageUrlToBase64 = async (url) => {
  const blob = await fetch(url).then((res) => res.blob());

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result.split(",")[1]);
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getEmailInlineImages = async () => {
  const waativaLogoBase64 = await imageUrlToBase64(waativaLogo);
  const suomalainenLogoBase64 = await imageUrlToBase64(suomalainenLogo);

  return [
    {
      name: "waativalogoteksilla.png",
      contentId: "waativaLogo",
      contentType: "image/png",
      contentBytes: waativaLogoBase64
    },
    {
      name: "Suomalaista_palvelua.png",
      contentId: "suomalaistaPalvelua",
      contentType: "image/png",
      contentBytes: suomalainenLogoBase64
    }
  ];
};